export default __webpack_public_path__ + "static/media/eye.de386af5.svg";